__turbopack_context__.v({
  "addNewItem": "m4W-fG_addNewItem",
  "addNewItemBusiness": "m4W-fG_addNewItemBusiness",
  "addNewItemBusinessForm": "m4W-fG_addNewItemBusinessForm",
  "addNewItemEmptyList": "m4W-fG_addNewItemEmptyList",
  "addNewItemSelect": "m4W-fG_addNewItemSelect",
  "button": "m4W-fG_button",
  "freeTextInput": "m4W-fG_freeTextInput",
});
